"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _reduxForm = require("redux-form");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _SummaryTable = _interopRequireDefault(require("./SummaryTable"));

var _ErrorsTable = _interopRequireDefault(require("./ErrorsTable"));

var _Alerts = _interopRequireDefault(require("./Alerts"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function CreateDialog(_ref) {
  var handleSubmit = _ref.handleSubmit,
      valid = _ref.valid,
      pristine = _ref.pristine,
      submit = _ref.submit;

  try {
    var collapseResults = function collapseResults() {
      setOpen(!isOpen);
    };

    var handleGetPayoutTemplate = function handleGetPayoutTemplate() {
      if (!valid) {
        return void 0;
      }

      dispatch((0, _functionalButton.getFileByName)(formValues['shopId']));
    };

    var handleCheckIsDuplicated = function handleCheckIsDuplicated() {
      if (!!file && file['data']['duplicatedFile']) {
        setDuplicated(true);
      } else {
        dispatch(submit('operation-payout-from-file'));
      }
    };

    var handleResetState = function handleResetState() {
      dispatch((0, _functionalButton.resetRegisterAction)());
      setDuplicated(false);
    };

    var dispatch = (0, _reactRedux.useDispatch)();

    var _useState = (0, _react.useState)(true),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        isOpen = _useState2[0],
        setOpen = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        isDuplicated = _useState4[0],
        setDuplicated = _useState4[1];

    var file = (0, _reactRedux.useSelector)(_functionalButton.selectFile);
    var shops = (0, _reactRedux.useSelector)(_functionalButton.selectShops);
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInSubmitProcess);
    var formValues = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('operation-payout-from-file'));
    var iconClassName = (0, _classnames["default"])(_defaultModule["default"]['file__caption-icon'], 'icon-xls');
    (0, _react.useEffect)(function () {
      if (formValues['shopId'] && formValues['file']) {
        dispatch((0, _functionalButton.checkFile)(formValues));
      }
    }, [formValues]);
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['dialog__wrapper'],
      "data-locator": 'payout.dialog',
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['dialog']
    }, inProcess && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['spinner']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Spinner, null)), isDuplicated && !inProcess && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['notification']
    }, /*#__PURE__*/_react["default"].createElement(_Notification["default"], {
      onReset: handleResetState
    })), /*#__PURE__*/_react["default"].createElement("article", {
      className: _defaultModule["default"]['dialog__content'],
      "data-locator": 'payout.dialog.content'
    }, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: 'Магазин',
      placeholder: 'Выбрать магазин',
      name: 'shopId',
      optionKey: 'id',
      optionValue: 'name',
      clearable: false,
      options: shops,
      disabled: inProcess,
      simple: true
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['dialog__notification']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment'
    }, "\u0415\u0441\u043B\u0438 \u0432\u044B\xA0\u0434\u0435\u043B\u0430\u0435\u0442\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u0438\u0437\xA0\u0444\u0430\u0439\u043B\u0430 \u043F\u0435\u0440\u0432\u044B\u0439 \u0440\u0430\u0437 \u0438\u043B\u0438 \u0432\u043E\u0437\u043D\u0438\u043A\u0430\u044E\u0442 \u043E\u0448\u0438\u0431\u043A\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438, \u043C\u043E\u0436\u043D\u043E \u0441\u043A\u0430\u0447\u0430\u0442\u044C ", /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(_defaultModule["default"]['link'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['disabled'], !valid)),
      onClick: handleGetPayoutTemplate
    }, "\u0448\u0430\u0431\u043B\u043E\u043D"), " \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['file']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['file__button']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.DropFileField, {
      name: "file",
      accept: ".xlsx",
      area: true,
      areaLabel: 'Перетащите сюда файл .xlsx',
      buttonLabel: 'Выбрать файл',
      disabled: !valid
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['dialog__notification-danger']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'error'
    }, "! \u041D\u0435\xA0\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \xAB.\xBB \u0432\xA0\u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044F \u0441\u0443\u043C\u043C\u044B"))), !!file && /*#__PURE__*/_react["default"].createElement("article", {
      className: _defaultModule["default"]['checking']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['file__caption']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: iconClassName
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['file__caption-label']
    }, formValues['file'] && formValues['file']['name'])), /*#__PURE__*/_react["default"].createElement(_Alerts["default"], {
      items: file['data']['accounts'],
      success: 'payouts' in file['data'] && !file['data']['overBalance'],
      shop: file['data']['shop'],
      summary: file['data']['summary'],
      commonErrors: file['data']['commonErrors'] || [],
      isOverBalance: file['data']['overBalance']
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__result']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__result-headline'],
      onClick: collapseResults
    }, 'payouts' in file['data'] ? 'Сводка по выплатам' : 'Ошибки в файле', /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('icon-arrow-down', _defaultModule["default"]['checking__result-headline-icon'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['collapsed'], !isOpen))
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['checking__result-holder'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['collapsed'], !isOpen))
    }, 'payouts' in file['data'] ? /*#__PURE__*/_react["default"].createElement(_SummaryTable["default"], {
      items: file['data']['summary']
    }) : /*#__PURE__*/_react["default"].createElement(_ErrorsTable["default"], {
      items: file['data']['rowErrors']
    }))))), !!file && /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['dialog__controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": 'payout.submit',
      type: 'button',
      mode: 'success',
      inProcess: inProcess,
      onClick: handleCheckIsDuplicated,
      disabled: !file || !('payouts' in file['data']) || !valid || pristine || file['data']['overBalance']
    }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = CreateDialog;
exports["default"] = _default;